import { Link } from "@tanstack/react-router";
import { Award } from "lucide-react";
import type * as React from "react";
import {
  EntityCardContent,
  EntityCardsGrid,
  entityCardClass,
} from "@/components/shared/entity-cards";
import { LifecycleBadge } from "@/components/shared/lifecycle-badge";
import type { Certification } from "@/hooks/use-certifications";
import { carryListSearch } from "@/lib/list-search";

interface CertificationCardsProps {
  certifications: Certification[];
  loading?: boolean;
  empty: React.ReactNode;
}

export function CertificationCards({ certifications, loading, empty }: CertificationCardsProps) {
  return (
    <EntityCardsGrid loading={loading} isEmpty={certifications.length === 0} empty={empty}>
      {certifications.map((certification) => (
        <Link
          key={certification.id}
          to="/dashboard/certifications/$certificationId"
          params={{ certificationId: certification.id }}
          search={carryListSearch()}
          aria-label={`Open ${certification.name}`}
          className={entityCardClass(true)}
        >
          <EntityCardContent
            icon={Award}
            title={certification.name}
            subtitle={certification.issuingBody || "No issuing body"}
            trailing={<LifecycleBadge status={certification.status} />}
          />
        </Link>
      ))}
    </EntityCardsGrid>
  );
}
